import { Color } from '@common/types/radix';
import { Badge } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';
import { Clip, ClipMediaObjectType } from '..';

interface MediaObjectTypeBadgeProps {
    clip: Clip;
}

const MEDIA_TYPE_COLORS: Record<ClipMediaObjectType, Color> = {
    VIDEO: 'indigo',
    AUDIO: 'crimson',
    IMAGE: 'amber',
    DOCUMENT: 'grass',
    PACKAGE: 'gray',
    // AUDIO: 'grass',
    // VIDEO: 'blue',
    // IMAGE: 'amber',
    // PACKAGE: 'crimson',
    // DOCUMENT: 'cyan',
};

export const MediaObjectTypeBadge = ({ clip }: MediaObjectTypeBadgeProps) => {
    const { t } = useTranslation('clipTable');

    if (!clip) return null;

    const { mediaObjectType } = clip;

    return (
        <Badge
            variant='soft'
            radius={'full'}
            color={MEDIA_TYPE_COLORS[mediaObjectType]}
            style={{ padding: '2px var(--space-2)' }}
        >
            {t(mediaObjectType)}
        </Badge>
    );
};
